"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryFieldDialog = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const ButtonGroup_1 = __importDefault(require("@material-ui/core/ButtonGroup"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const remote_table_field_1 = require("../remote-table-field/remote-table-field");
const common_types_1 = require("../../common/common-types");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const dictionary_field_styles_1 = require("./dictionary-field-styles");
const form_panel_1 = require("../../composite/form/fields/form-panel");
const checkbox_1 = require("../checkbox/checkbox");
const dialog_1 = require("../dialog/dialog");
const field_filter_hook_1 = require("../field-filter/field-filter-hook");
const field_filter_component_1 = require("../field-filter/field-filter-component");
const crud_source_hook_1 = require("../../utils/crud-source-hook");
exports.DictionaryFieldDialog = react_1.forwardRef(function DictionaryFieldDialog({ title = (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__DICTIONARY_FIELD__DIALOG_TITLE", defaultMessage: "V\u00FDb\u011Br" })), preFilters = [], filtersFields, columns, onChange, source, width = 700, multiple, maxRows = 10, detailUrl, }, ref) {
    const classes = dictionary_field_styles_1.useDialogStyles();
    const tableRef = react_1.useRef(null);
    const [selectedItems, setSelectedItems] = react_1.useState([]);
    const { filters, reset, handleFilterValueChange, handleFilterStateChange, search, } = field_filter_hook_1.useFilters({
        source,
        filtersFields,
        preFilters,
    });
    /**
     * Submits filled filters and refresh source.
     */
    const handleSearch = event_callback_hook_1.useEventCallback(async () => {
        var _a;
        search();
        await ((_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.setSelectedIndex(undefined));
        setSelectedItems([]);
    });
    /**
     * Reset filters and source into init state.
     */
    const handleReset = event_callback_hook_1.useEventCallback(async () => {
        var _a;
        reset();
        await ((_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.setSelectedIndex(undefined));
        setSelectedItems([]);
    });
    /**
     * Submits selected value.
     */
    const handleSubmit = event_callback_hook_1.useEventCallback(async () => {
        var _a;
        if (selectedItems.length !== 0) {
            if (!multiple) {
                let item = source.items.find((item) => item.id === selectedItems[0]);
                if (detailUrl) {
                    const fetch = crud_source_hook_1.defaultGetItem(detailUrl, selectedItems[0]);
                    item = await fetch.json();
                }
                onChange(item);
            }
            else {
                let items = source.items.filter((item) => selectedItems.includes(item.id));
                if (detailUrl) {
                    const detailedItems = await Promise.all(items.map(async (item) => {
                        const fetch = crud_source_hook_1.defaultGetItem(detailUrl, item.id);
                        return await fetch.json();
                    }));
                    items = detailedItems;
                }
                onChange(items);
            }
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.close();
        }
    });
    /**
     * Toggles selected item.
     */
    const toggleSelect = event_callback_hook_1.useEventCallback((id) => {
        const isSelected = selectedItems.find((attachmentId) => attachmentId === id);
        let selected = [];
        if (isSelected) {
            selected = selectedItems.filter((attachmentId) => attachmentId !== id);
        }
        else {
            selected = [...selectedItems, id];
        }
        setSelectedItems(selected);
    });
    /**
     * Checkbox Cell is displayed in case of multiple dictionary-field.
     */
    const CheckboxCell = react_1.useMemo(() => function CheckboxCell({ index }) {
        const value = !!selectedItems.find((attachmentId) => attachmentId === source.items[index].id);
        return (react_1.default.createElement(checkbox_1.Checkbox, { value: value, onChange: () => {
                toggleSelect(source.items[index].id);
            } }));
    }, [source, selectedItems, toggleSelect]);
    const tableColumns = react_1.useMemo(() => {
        return multiple
            ? [
                {
                    name: '',
                    datakey: 'selectedRow',
                    width: 50,
                    CellComponent: CheckboxCell,
                },
                ...columns,
            ]
            : columns;
    }, [CheckboxCell, columns, multiple]);
    return (react_1.default.createElement(dialog_1.Dialog, { ref: ref, title: title, showConfirm: false, onShow: handleReset, actions: [
            react_1.default.createElement(Button_1.default, { key: "submit", type: "submit", onClick: handleSubmit, variant: "outlined", color: "primary", disabled: setSelectedItems.length === 0 },
                react_1.default.createElement(Typography_1.default, { classes: { root: classes.buttonLabel } },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__DICTIONARY_FIELD__CONFIRM_BUTTON", defaultMessage: "Potvrdit" }))),
        ] }, () => (react_1.default.createElement("div", { style: { width } },
        react_1.default.createElement("form", { onSubmit: (e) => {
                e.preventDefault();
                handleSearch();
            }, className: classes.form },
            react_1.default.createElement("div", { className: classes.filters }, filtersFields.map((filter, index) => {
                var _a, _b;
                return (react_1.default.createElement(field_filter_component_1.FilterComponent, { key: index, filter: {
                        ...filter,
                        enabled: true,
                        operation: (_a = filter === null || filter === void 0 ? void 0 : filter.defaultOperation) !== null && _a !== void 0 ? _a : common_types_1.ApiFilterOperation.EQ,
                        value: '',
                    }, state: (_b = filters === null || filters === void 0 ? void 0 : filters[index]) !== null && _b !== void 0 ? _b : {}, onChangeValue: (value) => handleFilterValueChange(index, value), onChangeFilterState: (state) => handleFilterStateChange(index, state) }));
            })),
            react_1.default.createElement(ButtonGroup_1.default, { size: "small", variant: "outlined" },
                react_1.default.createElement(Button_1.default, { type: "submit", variant: "outlined", color: "primary", size: "small" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__DICTIONARY_FIELD__SUBMIT_BUTTON", defaultMessage: "Pou\u017E\u00EDt filtr" })),
                react_1.default.createElement(Button_1.default, { variant: "outlined", onClick: handleReset },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__DICTIONARY_FIELD__RESET_BUTTON", defaultMessage: "Zru\u0161it filtry" })))),
        react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__DICTIONARY_FIELD__ITEMS", defaultMessage: "Nalezen\u00E9 hodnoty" }) },
            react_1.default.createElement(remote_table_field_1.RemoteTableField, { columns: tableColumns, source: source, maxRows: maxRows, showToolbar: false, ref: tableRef, onSelect: (_, i) => toggleSelect(source.items[i].id), showRadioCond: () => !multiple }))))));
});
//# sourceMappingURL=dictionary-field-dialog.js.map